import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CancelButton, SaveButton } from "../input/Button";
import { Input } from "@fluentui/react-components";

const messages = defineMessages({
  title: {
    id: "edit-name-modal.title",
    defaultMessage: "Edit name"
  },
  name: {
    id: "edit-name-modal.name",
    defaultMessage: "Name"
  },
  save: {
    id: "edit-name-modal.save",
    defaultMessage: "Save"
  }
});

export function EditNameModal({ profile, onSave, onClose }) {
  const intl = useIntl();
  const [name, setName] = useState(profile.displayName);

  const handleChange = e => {
    setName(e.target.value);
  };

  const handleSave = () => {
    onSave(name);
    onClose();
  };

  const isDisabled = name === profile.displayName || name.trim() === "";

  return (
    <Modal
      onOpenChange={onClose}
      onClose={onClose}
      title={intl.formatMessage(messages.title)}
      actions={
        <>
          <CancelButton appearance="outline" onClick={onClose} />
          <SaveButton onClick={handleSave} disabled={isDisabled} />
        </>
      }
    >
      <Input
        appearance="filled-darker"
        value={name}
        onChange={handleChange}
        placeholder={intl.formatMessage(messages.name)}
        minLength={3}
        maxLength={30}
        style={{ width: "100%" }}
      />
    </Modal>
  );
}

EditNameModal.propTypes = {
  profile: PropTypes.object,
  onSave: PropTypes.func,
  onClose: PropTypes.func
};
